import { LucideIcon } from "lucide-react";

interface ChartEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  size?: "sm" | "md" | "lg";
}

export function ChartEmptyState({
  icon: Icon,
  title,
  description,
  size = "md"
}: ChartEmptyStateProps) {
  const sizeClasses = {
    sm: {
      container: "py-6",
      iconContainer: "p-2 mb-3",
      icon: "h-6 w-6",
      title: "text-sm font-medium",
      description: "text-xs"
    },
    md: {
      container: "py-8",
      iconContainer: "p-3 mb-4",
      icon: "h-8 w-8",
      title: "text-base font-medium",
      description: "text-sm"
    },
    lg: {
      container: "py-12",
      iconContainer: "p-4 mb-6",
      icon: "h-12 w-12",
      title: "text-lg font-semibold",
      description: "text-base"
    }
  };

  const classes = sizeClasses[size];

  return (
    <div className={`text-center ${classes.container}`}>
      <div
        className={`bg-primary/10 border border-primary/20 rounded-lg w-fit mx-auto ${classes.iconContainer}`}
      >
        <Icon className={`${classes.icon} text-primary/70`} />
      </div>
      <h3 className={`${classes.title} text-foreground mb-2`}>{title}</h3>
      <p
        className={`text-muted-foreground ${classes.description} leading-relaxed max-w-xs mx-auto`}
      >
        {description}
      </p>
    </div>
  );
}
